import React from "react";
import { Card, Table, TableBody, TableCell, TableRow } from "@mui/material";
import {
  CustomTableContainer,
  CustomTableHead,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import { useSelector } from "react-redux";
import { AdminTitleHolder } from "../../../common/sharedComponents/styles/card.style";
import moment from "moment";

function ProjectViewCompanyList() {
  const { projectDetails } = useSelector((state) => state.project);
  const users = projectDetails?.users;

  return (
    <div>
      <AdminTitleHolder sx={{ mt: 2 }}>
        <b>Assigned Users</b>
      </AdminTitleHolder>
      <CustomTableContainer component={Card}>
        <Table>
          <CustomTableHead>
            <TableRow>
              <TableCell>
                <TableHeaderFont>Name</TableHeaderFont>
              </TableCell>
              <TableCell>
                <TableHeaderFont>Email</TableHeaderFont>
              </TableCell>
              <TableCell>
                <TableHeaderFont>Assigned By</TableHeaderFont>
              </TableCell>
              <TableCell>
                <TableHeaderFont>Assigned Date</TableHeaderFont>
              </TableCell>
            </TableRow>
          </CustomTableHead>
          <TableBody>
            {users?.length > 0 ? (
              users.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {item?.user?.first_name} {item?.user?.last_name}
                  </TableCell>
                  <TableCell>
                    {item?.user?.contact_person_email || "-"}
                  </TableCell>
                  <TableCell>
                    {item?.assignedBy?.first_name} {item?.assignedBy?.last_name}
                  </TableCell>
                  <TableCell>
                    {moment(item?.assigned_at).format("DD-MM-YYYY")}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No users assigned
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CustomTableContainer>
    </div>
  );
}

export default ProjectViewCompanyList;
